module.exports = __webpack_public_path__ + "static/21-7dd07ef847db9affa9eab8e34a5a03c5.jpg";